import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ConfigProvider, Select, DatePicker, Pagination, Spin, Row, Col, message } from 'antd';
import InfiniteScroll from 'react-awesome-infinite-scroll';
import dayjs from 'dayjs';
import styles from './index.module.scss';
import { AppContext } from '../../../utils/AppContext';
import api from '@api/api';
import time_corner from '@assets/images/time_corner.svg'
import end_corner from '@assets/images/end_corner.svg'
import OrderItem from './components/orderItem';
const { Option } = Select;

//交付页
const ImageServiceDeliver = () => {
    const location = useLocation();

    const { updateConfig } = useContext(AppContext);
    useEffect(() => {
        updateConfig({ sidebarKey: 2 });
    }, []);

    const [orderStatus, setorderStatus] = useState()
    const [startDateVal, setStartDateVal] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDateVal, setEndDateVal] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [pageIndex, setpageIndex] = useState(1);
    const [orderId, setorderId] = useState('');
    const [total, settotal] = useState(0);
    const [skuList, setskuList] = useState([]);
    const [isSpinning, setisSpinning] = useState(false);

    useEffect(() => {
        listWithSku()
    }, [])

    const searchClick = () => {
        listWithSku()
    }

    useEffect(() => {
        console.log(startDate)
        console.log(endDate)
        console.log(orderStatus)
        if(startDate == null && endDate == null && !orderStatus) {
            listWithSku()
        }
    }, [startDate, endDate, orderStatus])
  

    const handleReset = () => {
        setStartDate(null)
        setStartDateVal(null)
        setEndDate(null)
        setEndDateVal(null)
        setorderStatus()
    }

    const handleStatusChange = (val) => {
        setorderStatus(val)
    }

    const handleStartDateChange = (date, dateString) => {
        setStartDateVal(date)
        setStartDate(dateString);
    };

    const handleEndDateChange = (date, dateString) => {
        setEndDateVal(date)
        setEndDate(dateString);
    };

    const listWithSku = () => {
        setisSpinning(true)
        api.listWithSku({
            status: orderStatus,
            start: startDate,
            end: endDate,
            pageIndex: 1,
            pageSize: 1000,
            orderId: orderId
        }).then((res) => {
            setisSpinning(false)
            if (res.code == 0) {
                settotal(res.data.total)
                setskuList(res.data.items)
            } else {
                message.warning(res.message)
            }
        })
    }

    const pageChange = (page) => {
        console.log(page)
        setpageIndex(page)
    }


    return (
        <div className={styles.ImageServiceDeliver}>
            <Spin spinning={isSpinning}>
            <div className={styles.title}>内容交付</div>
            <div className={styles.searchBox}>
                <span className={styles.spanStyl}>订单状态</span>
                <Select
                    placeholder="请选择"
                    value={orderStatus}
                    onChange={handleStatusChange}
                    style={{ width: '2.64rem' }}
                >
                    <Option value="">全部</Option>
                    {/* <Option value={1}>待确认</Option> */}
                    <Option value={2}>进行中</Option>
                    <Option value={3}>已完成</Option>
                    {/* <Option value={4}>已拒绝</Option> */}
                </Select>
                <span className={styles.spanStyl} style={{ marginLeft: '1rem' }}>底片交付日期</span> 
                <DatePicker
                    placeholder="请选择开始时间"
                    onChange={handleStartDateChange}
                    value={startDateVal}
                    style={{ width: '2.64rem' }}
                />
                <span className={styles.spanStyl_}>至</span>
                <DatePicker
                    placeholder="请选择结束时间"
                    value={endDateVal}
                    onChange={handleEndDateChange}
                    style={{ width: '2.64rem' }}
                />
                <button style={{width:'75px', height:'26px', marginLeft: '20px', borderRadius:'12px', backgroundColor:'rgba(248, 249, 255, 1)', border:'1px solid rgba(192, 203, 244, 1)'}} onClick={searchClick}>
                    搜索
                </button>
                <img style={{marginLeft:'.1rem',marginBottom:'.05rem', width: '24px', height: '24px', cursor: 'pointer', display: 'inline-block' }} src={require('@assets/images/reset_btn.png')} alt="重置所有选项" onClick={handleReset} />
            </div>
            <div className={styles.content}>
                {
                    skuList.map((item) => {
                        return <div className={styles.contentOrder}>
                            <div className={styles.orderTitle}>
                                <span>订单编号：{item.orderId}</span>
                                <span>底片交付日期：{item.deliveryTime}</span>
                                {
                                    item.status == 1?<span className={styles.confirm_}><img className={styles.corner_} src={time_corner} />待确认</span>:
                                    item.status == 2?<span className={styles.confirm_}><img className={styles.corner_} src={time_corner} />进行中</span>:
                                    item.status == 3?<span className={styles.confirm_}><img className={styles.corner_} src={time_corner} />已完成</span>:
                                    item.status == 4?<span className={styles.confirm_4}><img className={styles.corner_} src={time_corner} />已拒绝</span>: null
                                }
                            </div>
                            <div className={styles.itemBox}>
                                {
                                    item.skuList.map((item2) => {
                                        return <OrderItem key={item2.id} item2={item2}/>
                                    })
                                }
                            </div>
                        </div>
                    })
                }

            </div>
            {/* <Pagination showSizeChanger={false} className={styles.pagina_} current={pageIndex} onChange={pageChange} total={total} size="small" /> */}
            </Spin>
        </div>
    );
}

export default ImageServiceDeliver